// @flow
import * as React from 'react';
import { IconButton } from '../../buttons/icon_buttons';
import CloseIcon from '../../../icons/close';
import DropdownArrowIcon from '../../../icons/dropdown_arrow';
import styled, { type StyledComponent } from 'styled-components';

type EndAdornmentProps = {
  reset: function,
  selectedItems: Array<any>,
  singleSelect: boolean,
  disabled: boolean,
};

const EndAdornment = ({
  reset,
  singleSelect,
  selectedItems,
  disabled,
}: EndAdornmentProps) => {
  if (disabled) {
    return null;
  }

  return (
    <EndAdornmentWrapper>
      {!singleSelect && selectedItems.length > 1 && (
        <IconButton
          data-provides={'clear-selection-icon'}
          icon={CloseIcon}
          label={'Clear Selection'}
          size="sm"
          onClick={() => {
            reset();
          }}
        />
      )}
      <IconContainer>
        <DropdownArrowIcon size="sm" />
      </IconContainer>
    </EndAdornmentWrapper>
  );
};

const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  padding: 0.25rem;
`;

const EndAdornmentWrapper: StyledComponent<*, *, *> = styled.span`
  display: flex;
`;

export default EndAdornment;
